import {formatFileSize} from "../../../../utils/utils";
import TmdbResultCard from "../../tmdbResultCard/tmdbResultCard";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import users from "../../../users";
import './torrentDownloadItem.css';

const TorrentDownloadItem = ({torrent, onRemoveTorrent}) => {

    const navigate = useNavigate();
    const darkMode = useSelector(users.selectors.isDarkMode);

    const getTorrentName = () => {
        const name = `${torrent.name}`;

        if (torrent.tmdbInfo.title) {
            return {title: name};
        }
        return {name};
    }

    return (

        <div key={torrent.id}>
            <TmdbResultCard
                props={{...torrent.tmdbInfo, ...getTorrentName()}}
                linked={false}
                customBottomInfo={
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "10px",
                    }}>
                        <div className="progress" role="progressbar" aria-label="Example with label"
                             aria-valuenow="25"
                             aria-valuemin="0" aria-valuemax="100" style={{
                            position: "relative",
                            width: "100%",
                            backgroundColor: darkMode ? "#3e4245" : "#a8a8a8",
                        }}>
                            <div className="progress-bar progress-bar-striped progress-bar-animated"
                                 style={{
                                     width: `${torrent.progress * 100}%`
                                 }}>{(torrent.progress * 100).toFixed(1)}%

                                <div style={{
                                    position: "absolute",
                                    right: "6px",
                                    textWrap: "nowrap",
                                }}>&nbsp;&nbsp;{torrent.downloadSpeed}</div>
                            </div>
                        </div>
                        <span className="badge text-bg-secondary">{formatFileSize(parseInt(torrent.total_size))}</span>
                        <span className="badge text-bg-danger remove-torrent-button" onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();
                            onRemoveTorrent(torrent.id);
                        }}>
                            <i className="fa-solid fa-ban"></i>
                        </span>
                    </div>
                }/>
        </div>
    );
}

export default TorrentDownloadItem;
